"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_aad_msal_1 = require("react-aad-msal");
var reduxStore_1 = require("../reduxStore");
//import GetAccessTokenButton from "./GetAccessTokenButton";
//import GetIdTokenButton from "./GetIdTokenButton";
// Import the authentication provider which holds the default settings
var authProvider_1 = require("../authProvider");
var SampleAppButtonLaunch = function () {
    // Change the login type to execute in a Popup
    var options = authProvider_1.authProvider.getProviderOptions();
    options.loginType = react_aad_msal_1.LoginType.Popup;
    authProvider_1.authProvider.setProviderOptions(options);
    return (React.createElement(react_aad_msal_1.AzureAD, { provider: authProvider_1.authProvider, reduxStore: reduxStore_1.basicReduxStore }, function (_a) {
        var login = _a.login, logout = _a.logout, authenticationState = _a.authenticationState;
        var isInProgress = authenticationState === react_aad_msal_1.AuthenticationState.InProgress;
        var isAuthenticated = authenticationState === react_aad_msal_1.AuthenticationState.Authenticated;
        var isUnauthenticated = authenticationState === react_aad_msal_1.AuthenticationState.Unauthenticated;
        if (isAuthenticated) {
            return (React.createElement(React.Fragment, null,
                React.createElement("p", null, "You're logged in!"),
                React.createElement("button", { onClick: logout, className: "Button" }, "Logout")));
        }
        else if (isUnauthenticated || isInProgress) {
            return (React.createElement("button", { className: "Button", onClick: login, disabled: isInProgress }, "Login"));
        }
    }));
};
exports.default = SampleAppButtonLaunch;
//# sourceMappingURL=LoginLaunch.js.map